// Used for Live & JumpBall bidding types
export enum OpenBiddingStatus {
    stage1Ended = 1,
    improvementRoundEnded = 2
}
